import _noop from 'lodash/noop'
import { useState } from 'react'
import ClearIcon from '@mui/icons-material/Clear'
import IconButton from '@mui/material/IconButton'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import MuiTextField, { TextFieldProps } from '@mui/material/TextField'

type ComponentProps = TextFieldProps & {
  clearable?: boolean
  onClear?: () => void
}

function TextField(props: ComponentProps) {
  const {
    variant = 'standard',
    size = 'small',
    clearable = false,
    onClear = _noop,
    InputProps,
    type,
    ...textFieldProps
  } = props

  const [showPassword, setShowPassword] = useState(() => type !== 'password')

  return (
    <MuiTextField
      variant={variant}
      size={size}
      type={showPassword && type !== 'password' ? type : showPassword ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <>
            {clearable && !textFieldProps.disabled && (textFieldProps.value || textFieldProps?.inputProps?.value) ? (
              <ClearIcon sx={{ color: 'gray', cursor: 'pointer', fontSize: 18 }} onClick={onClear} />
            ) : null}
            {type === 'password' && textFieldProps.value ? (
              <IconButton sx={{ p: 0 }} onClick={() => setShowPassword((prev) => !prev)}>
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            ) : null}
          </>
        ),
        ...InputProps,
      }}
      {...textFieldProps}
    />
  )
}

export default TextField
